import React from "react";
import {
  Mail,
  Phone,
  MapPin,
  Instagram,
  Facebook,
  ArrowUpRight,
  ShieldCheck,
} from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#4B3621] text-white pt-10 pb-6">
      <div className="max-w-7xl mx-auto px-6">

        {/* Top Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">

          {/* Brand */}
          <div>
            <h3 className="text-xl font-black tracking-tighter mb-4">
              GURU'S <span className="text-[#D4AF37]">FARMS.</span>
            </h3>
            <p className="text-white/50 text-[12px] leading-relaxed mb-4 italic">
              "Pioneering elite genetics and biological security in livestock farming."
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-[#2D5A27] transition-colors"
              >
                <Instagram size={14} />
              </a>
              <a
                href="#"
                className="w-8 h-8 rounded-full border border-white/10 flex items-center justify-center hover:bg-[#2D5A27] transition-colors"
              >
                <Facebook size={14} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-[9px] font-black uppercase tracking-[0.3em] text-[#D4AF37] mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              {["About", "Products", "Gallery"].map((item) => (
                <li key={item}>
                  <Link
                    to={`/${item.toLowerCase()}`}
                    className="text-[12px] font-medium text-white/70 hover:text-white flex items-center gap-2 group"
                  >
                    {item}
                    <ArrowUpRight
                      size={12}
                      className="opacity-0 group-hover:opacity-100 transition-opacity"
                    />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[9px] font-black uppercase tracking-[0.3em] text-[#D4AF37] mb-4">
              Contact
            </h4>
            <ul className="space-y-2 text-[12px] text-white/70 font-medium">
              <li className="flex items-center gap-2">
                <Phone size={14} className="text-[#D4AF37]" />
                +91 77299 83005
              </li>
              <li className="flex items-center gap-2">
                <Mail size={14} className="text-[#D4AF37]" />
                contact@gurufarms.com
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={14} className="text-[#D4AF37]" />
                Bommanapalli, Gangavaram, Palamaner, AP
              </li>
            </ul>
          </div>

          {/* Status Card */}
          <div className="bg-white/5 p-5 rounded-[1.5rem] border border-white/10 border-dashed relative overflow-hidden">
            <ShieldCheck className="absolute -right-2 -top-2 text-white/5 w-16 h-16" />
            <h4 className="text-[9px] font-black uppercase tracking-[0.3em] text-[#D4AF37] mb-2">
              Status
            </h4>
            <p className="text-lg font-black mb-1 tracking-tighter italic text-white">
              Verified Stock
            </p>
            <p className="text-[10px] text-white/40 mb-4">
              DNA verified genetics batch.
            </p>
            <Link
              to="/contact"
              className="block text-center bg-[#D4AF37] text-white text-[9px] font-black uppercase tracking-widest py-2 rounded-lg hover:bg-white hover:text-[#4B3621] transition-all"
            >
              Inquire
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 pt-6 text-center">
          <p className="text-[#F5E6C8] text-[9px] tracking-widest uppercase opacity-60">
            © {currentYear} GURU'S Livestock & Poultry Farms | Developed By{" "}
            <a
              href="https://geniusmindstech.com/"
              target="_blank"
              rel="noreferrer"
              className="text-[#D4AF37] hover:underline"
            >
              geniusmindstech.com
            </a>
          </p>
        </div>

        <div className="flex gap-6 mt-4 justify-center text-[9px] font-bold text-white/30 uppercase tracking-widest">
          <Link
            to="/privacy"
            className="hover:text-[#D4AF37] transition-colors underline decoration-white/10 underline-offset-4"
          >
            Privacy Policy
          </Link>
        </div>

      </div>
    </footer>
  );
}
